<div class="back-button">
  <div class="container-back">
    <div class="button" (click)="onBackButtonClicked()">
      <app-svg-icon src="./assets/icons/union_left.svg"></app-svg-icon>
    </div>
    <div class="title" (click)="onBackButtonClicked()">{{ title }}</div>
  </div>
</div>
